import { Plus, X } from "lucide-react";

import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogDescription, DialogTitle } from "@/components/ui/dialog";

import ItensLancados from "./ItensLancados";
import { reais, tempoAberta } from "./lib";

/**
 * Olhinho do cartão (dono, 25/10/2026, igual Mesas): tudo que está na comanda,
 * com foto, cancelados e transferidos recolhidos. Só leitura; "Adicionar
 * itens" leva para a comanda aberta (não aparece em fechamento).
 */
export default function VerComandaDialog({ detalhe, allProducts, onClose, onAdicionar }) {
  const c = detalhe;
  const nn = String(c?.numero || 0).padStart(2, "0");
  return (
    <Dialog open={!!c} onOpenChange={(v) => { if (!v) onClose(); }}>
      <DialogContent hideClose data-e2e="comanda-ver-dialog" className="sm:max-w-lg p-0 gap-0 max-h-[90dvh] flex flex-col overflow-hidden">
        <div className="bg-primary text-primary-foreground px-5 pt-5 pb-4">
          <div className="flex items-start gap-3">
            <div className="min-w-0">
              <p className="text-[11px] uppercase tracking-widest opacity-80">Comanda</p>
              <DialogTitle className="text-2xl font-black truncate">
                {nn}{c?.cliente_nome ? ` · ${c.cliente_nome}` : ""}
              </DialogTitle>
            </div>
            <button type="button" onClick={onClose} aria-label="Fechar" className="ml-auto -mr-1 p-1.5 rounded-full hover:bg-white/15 transition-colors">
              <X className="w-5 h-5" />
            </button>
          </div>
          <DialogDescription className="sr-only">Os itens lançados na comanda, com o total.</DialogDescription>
          <div className="mt-2 flex items-end justify-between gap-3">
            <span className="text-sm opacity-90 truncate">
              aberta há {tempoAberta(c?.opened_at)}{c?.em_fechamento ? " · em fechamento" : ""}
            </span>
            <span className="text-2xl font-black tabular-nums shrink-0" data-e2e="comanda-ver-total">{reais(c?.total)}</span>
          </div>
        </div>
        <div className="px-5 py-2 overflow-y-auto flex-1">
          <ItensLancados items={c?.pedido?.items} allProducts={allProducts} podeAgir={false} />
        </div>
        {!c?.em_fechamento && (
          <div className="p-3 border-t">
            <Button onClick={() => onAdicionar(c)} className="w-full h-11 bg-orange-500 hover:bg-orange-600 text-white font-bold">
              <Plus className="w-4 h-4 mr-1" /> ADICIONAR ITENS
            </Button>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}
